import { z } from 'zod'

export const createCandidateSchema = z.object({
  email: z.string().email('Invalid email address'),
  firstName: z
    .string()
    .min(1, 'First name is required')
    .max(100, 'First name must be less than 100 characters'),
  lastName: z
    .string()
    .min(1, 'Last name is required')
    .max(100, 'Last name must be less than 100 characters'),
  phone: z.string().max(50).optional(),
  location: z.string().max(200).optional(),
  linkedinUrl: z.string().url().optional().or(z.literal('')),
  portfolioUrl: z.string().url().optional().or(z.literal('')),
  skills: z.array(z.string().max(50)).max(50).default([]),
  experienceYears: z.number().int().min(0).max(60).optional(),
  currentTitle: z.string().max(200).optional(),
  currentCompany: z.string().max(200).optional(),
  source: z.string().max(100).optional(),
  sourceDetails: z.string().max(500).optional(),
  tags: z.array(z.string().max(50)).max(20).default([]),
})

export const updateCandidateSchema = createCandidateSchema.partial()

export const candidateFiltersSchema = z.object({
  search: z.string().max(200).optional(),
  skills: z.array(z.string()).optional(),
  source: z.string().optional(),
  tags: z.array(z.string()).optional(),
  minExperience: z.coerce.number().int().min(0).optional(),
  maxExperience: z.coerce.number().int().max(60).optional(),
})

export const createNoteSchema = z.object({
  applicationId: z.string().optional(),
  candidateId: z.string().optional(),
  content: z.string().min(1).max(10000),
  isPrivate: z.boolean().default(false),
}).refine(
  (data) => data.applicationId || data.candidateId,
  { message: 'Either applicationId or candidateId is required' }
)

export const updateNoteSchema = z.object({
  content: z.string().min(1).max(10000).optional(),
  isPrivate: z.boolean().optional(),
})

export type CreateCandidateInput = z.infer<typeof createCandidateSchema>
export type UpdateCandidateInput = z.infer<typeof updateCandidateSchema>
export type CandidateFiltersInput = z.infer<typeof candidateFiltersSchema>
export type CreateNoteInput = z.infer<typeof createNoteSchema>
export type UpdateNoteInput = z.infer<typeof updateNoteSchema>
